export const scrollToNext = () => {};

export const delayedScrollToNext = (delay) => (e) => {
    e.persist();
    setTimeout(() => scrollToNext(e), delay);
};
